import ApplicationController from "../../../../application_controller"

export default class extends ApplicationController {
    static targets = ["checkbox"]

    connect() {
        this.element.addEventListener("click", this.handleClick.bind(this))
    }

    handleClick(event) {
        if (!this.hasCheckboxTarget) return;
        if (event.shiftKey) return;
        // A list with its own row selection, such as the lead list, decides what a click does.
        if (this.element.closest("[data-custom-row-selection]")) return;

        const checkbox = this.checkboxTarget

        if (event.target == checkbox ||
            (event.target.tagName !== "TD" && event.target.tagName !== "TH")) {
            return
        }

        checkbox.click();
    }
}
